import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.use(ElementUI)

// 配置axios
// 在实际应用中，可以设置baseURL
axios.defaults.baseURL = '/api'

// 请求拦截器，为每个请求添加token
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // 为所有请求添加manager请求头
    config.headers['manager'] = true
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器，处理错误
axios.interceptors.response.use(
  response => {
    // 如果状态码不是200，也当作错误处理
    if (response.data && response.data.status === 405) {
      // 令牌超时，清除token并跳转到登录页
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      router.push('/login')
      return Promise.reject({
        response: {
          data: {
            message: '登录已过期，请重新登录'
          }
        }
      });
    } else if (response.data && response.data.status !== 200) {
      return Promise.reject({
        response: {
          data: response.data
        }
      });
    }
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // 未授权，清除token并跳转到登录页
      localStorage.removeItem('token')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 